import React from "react";
import { connect } from "react-redux";
import Button from "../../UI-components/Button";
import Popup from "../../UI-components/Popup.js";
import * as actions from "../../../store/actions";
import { IMAGE_TEMPLATE_LIST } from "../../../config.js";
import CustomSelect from "../../UI-components/CustomSelect";

class ManageBulkUserPopup extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
          disableSave: true,
          showConfirmationPopup: false
        }
    }

    toggleConfirmBulkSavePopup = () => { this.setState({showConfirmationPopup: !this.state.showConfirmationPopup}); }

    handleSaveUserList = () => { 
      this.toggleConfirmBulkSavePopup();
      this.props.saveUserList(this.props.selectedUsers); 
    }

    handleImageModeSelector = (e) => {
      for (const user of this.props.selectedUsers) {
        let imageModeApplied = false;
        for (const grant of user.grants) {
          if (grant.grantType === "image") {
            grant.grantCode = e.value;
            imageModeApplied = true;
          }
        }
        if (!imageModeApplied) {
          user.grants.push({
            grantCode: e.value,
            grantType: "image",
            permissionType: "view",
            userId: user.userId
          })
        }
      }

      this.setState({disableSave: false});
    }

    render() {
      return (
        <div className="manage-user-popup-wrapper">
          <div className="popup-background" onClick={this.props.close}/>
          <div className="popup-container-user-bulk">
            <div className="close-popup" onClick={this.props.close}>
              <span className="icon-plus" />
            </div>
            <div className="popup-header">
              <div className="section-container-bulk">
                <div className="header-container">
                  <div className="image-selector">
                    <p className="image-selector-label">BACK OFFICE IMAGE MODE</p>
                    <CustomSelect
                      placeholder={"Select mode"}
                      handleChange={this.handleImageModeSelector}
                      options={IMAGE_TEMPLATE_LIST}
                    />
                  </div>
                  <div>
                    <Button
                      btnClass="btn-medium"
                      handleClick={this.toggleConfirmBulkSavePopup}
                      disabled={this.props.saveLoading || this.state.showConfirmationPopup || this.state.disableSave}
                    >
                      Save
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          { this.state.showConfirmationPopup ? (
            <Popup
              btnName="Yes"
              btnName2="Cancel"
              isDoubleButton={true}
              handleClick={this.handleSaveUserList}
              close={this.toggleConfirmBulkSavePopup}
              selectedUsers={this.props.selectedUsers}
              title = "Do you want to confirm the modification made to the selected users?"
            />
          ) : null }
        </div>
      );
    }

}

const mapStateToProps = (state) => {
  return {
    saveLoading: state.user.saveLoading
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    saveUserList: (currentUser) => dispatch(actions.saveUserList(currentUser)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ManageBulkUserPopup);